







































import { Component, Vue } from "vue-property-decorator";
import dashboardModule from "@/store/modules/dashboard-module";
import { dashboard } from "@/shared/dtos/dashboard";
import { MessageService } from "@/shared/services/message-service";
import { singleOrDoubleRowClick } from "@/utils/dblclickrow";
import { RouterNames } from "@/router/routernames";
@Component({
  components: {
  },
})
export default class config_dashboards_lista extends Vue {
      public search: string = "";
  public created() {
    dashboardModule.getdashboards();

  }

  public get datasource() {
    return dashboardModule.dashboards;
  }
 

  public get headers() {
    return [
      {
        text: "ID",
        align: "start",
        value: "id",
      },{
        text: "Nombre del dashboard",
        align: "start",
        value: "nombre",
      },
      { text: "", value: "acciones", align: "end" }
    ];
  }

  /**
   * editar
   */
  public editar_rw(obj: dashboard) {
  this.$router.push({name:RouterNames.dashboardsformulario,params:{id:obj.id}});
  }

  /**
   * add_new
   */
  public add_new() {
      this.$router.push({name:RouterNames.dashboardsformulario,params:{id:"-1"}});
  }
  /**
   *eliminar
   */
  public eliminar(obj: dashboard) {
    MessageService.confirm(
      "¿Seguro que quiere eliminar " + obj.nombre + "?",
      "Eliminar",
      (x: boolean) => {
        if (x) {
          dashboardModule.eliminardashboard(obj).then(()=>{dashboardModule.getdashboards()});
        }
      }
    );
  }

  
  public dblclick(item: any, singleClickFunc: any, doubleClickFunc: any) {
    singleOrDoubleRowClick(item, singleClickFunc, doubleClickFunc);
  }
}
